export function removeEmptyValues(object) {
    return Object.entries(object).reduce((previous, [key, value]) => {
        if (!value) {
            return previous;
        }
        return Object.assign(Object.assign({}, previous), { [key]: value });
    }, {});
}
//# sourceMappingURL=removeEmptyValues.js.map